module.exports = (__webpack_require__("dll-reference vendor_7ba712b40ab14c215732"))("./node_modules/socket.io-client/build/esm/index.js");